import moment from 'moment';
import { matchesLegalFilter } from './legalStatus';

// Filters of the admin Users page. One pure predicate, so the list and the
// counts shown next to each filter option always agree.
export const ROLE_FILTERS = [
  { value: 'all', label: 'All' },
  { value: 'forecaster', label: 'Forecaster' },
  { value: 'market_owner', label: 'Market Owner' },
  { value: 'admin', label: 'Administrator' },
];
export const ACTIVITY_FILTERS = [
  { value: 'all', label: 'Any' },
  { value: 'active_30', label: 'Active (last 30 days)' },
  { value: 'inactive_week', label: 'Inactive (1+ week)' },
  { value: 'never_logged_in', label: 'Never logged in' },
];
export const TERMS_FILTERS = [
  { value: 'all', label: 'Any' },
  { value: 'accepted', label: 'Accepted' },
  { value: 'pending', label: 'Pending' },
];

// Canonical role used for filtering and sorting.
export const roleValue = (u) => {
  if (u?.is_superuser) return 'admin';
  if (u?.is_forecaster) return 'forecaster';
  // Keep explicit 'market_owner_read' if the backend provides it.
  if (u?.role === 'market_owner_read') return 'market_owner_read';
  return 'market_owner';
};

export function matchesUserFilters(u, { search = '', role = 'all', activity = 'all', legal = 'all' }, now = moment()) {
  const query = search.trim().toLowerCase();
  if (query && ![u.email, u.first_name, u.last_name].some((v) => (v || '').toLowerCase().includes(query))) return false;

  if (role && role !== 'all') {
    const rv = roleValue(u);
    if (role === 'market_owner_read') {
      if (!(u.role === 'market_owner_read' || rv === 'market_owner')) return false;
    } else if (rv !== role) return false;
  }

  if (activity === 'active_30' && !(u.last_login && moment(u.last_login).isSameOrAfter(moment(now).subtract(30, 'days')))) return false;
  if (activity === 'inactive_week' && !(u.last_login && moment(u.last_login).isBefore(moment(now).subtract(1, 'week')))) return false;
  if (activity === 'never_logged_in' && u.last_login) return false;

  return matchesLegalFilter(u, legal);
}
